import "./AuthForm.css";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import {
  LOGIN_USERNAME_NAME,
  LOGIN_PASSWORD_NAME,
  SUCCESS_LOGIN_STATUS_CODE,
  UPDATE_USER_NOGLITCH_LATENCY,
  TOAST_NOGLITCH_LATENCY,
  MIN_TEXT_INPUT_LIMIT,
  MAX_TEXT_INPUT_LIMIT,
} from "@constants/Auth.constants.js";
import { AuthContext } from "@contexts/AuthContext";
import { loginAuth, fetchProfile } from "@libs/apiRequest.js";

const AuthForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const { updateUser } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData(e.target);
    const username_input = formData.get(LOGIN_USERNAME_NAME);
    const password_input = formData.get(LOGIN_PASSWORD_NAME);

    try {
      const login_response = await loginAuth(username_input, password_input);
      if (login_response === SUCCESS_LOGIN_STATUS_CODE) {
        const encodedProfileData_reponse = await fetchProfile();

        if (encodedProfileData_reponse) {
          setTimeout(() => {
            updateUser(encodedProfileData_reponse); // Delay updating `currentUser`
          }, UPDATE_USER_NOGLITCH_LATENCY); // Adjust delay to match animation timing

          setTimeout(() => {
            toast.success(`Login Successfully!`);
          }, TOAST_NOGLITCH_LATENCY);
        }
        navigate("/home");
      }
    } catch (err) {
      console.log(`${err.message}`);
      toast.error(`Login failed. Please try again.`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className="AuthForm__form" onSubmit={handleSubmit}>
      <div className="AuthForm__inputfield">
        <div className="AuthForm__inputset">
          <label htmlFor="username" className="AuthForm__label">
            Username
          </label>
          <input
            id="username"
            name={LOGIN_USERNAME_NAME}
            type="text"
            required
            minLength={MIN_TEXT_INPUT_LIMIT}
            maxLength={MAX_TEXT_INPUT_LIMIT}
            autoComplete="username"
            placeholder="Enter your username *"
            className="AuthForm__input"
          />
        </div>

        <div className="AuthForm__inputset">
          <label htmlFor="password" className="AuthForm__label">
            Password
          </label>
          <div className="AuthForm__inputWrapper">
            <input
              name={LOGIN_PASSWORD_NAME}
              type={showPassword ? "text" : "password"}
              required
              placeholder="Enter your password *"
              className="AuthForm__input"
            />
            <button
              type="button"
              className="AuthForm__showPasswordBtn"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </button>
          </div>
        </div>
      </div>

      <Button
        variant="contained"
        size="large"
        sx={{
          width: "90%",
          height: "50px",
          borderRadius: "5px",
          padding: "10px",
          textTransform: "capitalize",
          fontWeight: "bold",
          backgroundColor: "secondary.main",
          color: "white",
          borderColor: "secondary.main",
          "&:hover": {
            backgroundColor: "primary.main",
            color: "white",
            borderColor: "primary.main",
          },
        }}
        type="submit"
        disabled={isLoading}
      >
        Login
      </Button>
    </form>
  );
};

export default AuthForm;
